import { Chip, styled } from '@mui/material';
import colors from '../../style/color';

interface ChipForDisplayProps {
    size?: 'small' | 'medium';
}

const ChipForDisplay = styled(Chip)<ChipForDisplayProps>(({ size }) => ({
    color: colors.mediumJade,
    borderColor: colors.mediumJade,
    background: colors.chipJade,
    height: size === 'small' ? '20px' : '28px',
    fontSize: size === 'small' ? '0.6rem' : '0.875rem',
    '& .MuiChip-deleteIcon': {
        marginRight: size === 'small' ? '7px' : '10px',
        marginLeft: '0px',
    },
    '& .MuiChip-label': {
        paddingLeft: size === 'small' ? '6px' : '8px',
        paddingRight: size === 'small' ? '8px' : '12px',
    },
}));

export default ChipForDisplay;
